import { ModuleWithProviders, NgModule } from '@angular/core';

import { CookieService } from './service/cookie.service';
import { LocalStorageService } from './service/local-storage.service';
import { SessionStorageService } from './service/session-storage.service';

@NgModule({})
export class StorageModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: StorageModule,
      providers: [CookieService, LocalStorageService, SessionStorageService],
    };
  }

  public static forChild(): ModuleWithProviders {
    return {
      ngModule: StorageModule,
    };
  }
}
